// 教学班级
export const STU_LEARNINGPROGRESS = 'stu_learningprogress'
export const STU_ACTIVITYTAKE = 'stu_activitytake'
export const STU_ACTIVITYTIME = 'stu_activitytime'
export const STU_ATTENDANCE = 'stu_attendance'
export const STU_PREPAREWARNING = 'stu_preparewarning'
export const STU_JOBWARNING = 'stu_jobwarning'
export const STU_ACTIVITYWARNING = 'stu_activitywarning'
export const STU_EVALUATE = 'stu_evaluate'
export const STU_TEACHDETAIL = 'stu_teachdetail'
export const STU_INFORMATION = 'stu_information'
export const STU_TESTCONDITION = 'stu_testcondition'
export const STU_EVALUATECONDITION = 'stu_evaluatecondition'
export const STU_JOBCONDITION = 'stu_jobcondition'
export const STU_INFO = 'stu_info'
export const STU_SIGNCONDITION = 'stu_signcondition'
export const STU_PREPARECONDITION = 'stu_preparecondition'
export const STU_LEARNINGPROGRESS_WARNING = 'stu_learningprogress_warning'